import { iconSizes } from '@kinetik/ui-kit';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const HolidayIcon = ({
  color = COLORS.kinetikBlack,
  size = iconSizes.default,
  sx = {},
  ...props
}) => (
  <SvgIcon sx={{ width: size, height: size, ...sx }} {...props}>
    <path
      fill={color}
      d="M22.336 21.469a.75.75 0 0 1-1.055.117c-.035-.028-3.64-2.836-9.281-2.836-5.642 0-9.248 2.812-9.281 2.837a.75.75 0 1 1-.938-1.173c.153-.122 3.611-2.837 9.215-3.136a11.243 11.243 0 0 1-.309-3.556c.163-2.035 1.024-4.746 4.032-6.795a6.061 6.061 0 0 0-1.57-.177c-1.781.058-2.9 1.098-3.422 3.18a.75.75 0 1 1-1.455-.362C9.14 6.104 11.376 5.31 13.1 5.256a7.64 7.64 0 0 1 2.033.23c-.36-.594-.884-1.213-1.614-1.524-.937-.398-2.078-.224-3.404.516a.751.751 0 0 1-.73-1.312c1.756-.98 3.348-1.176 4.732-.581 1.17.502 1.943 1.479 2.425 2.343.58-.903 1.301-1.516 2.099-1.775 1.112-.363 2.31-.068 3.563.878a.75.75 0 0 1-.904 1.196c-.836-.63-1.572-.849-2.19-.65-.683.221-1.206.938-1.534 1.558a6.606 6.606 0 0 1 1.924.715c1.37.783 3 2.442 3 5.9a.75.75 0 0 1-1.5 0c0-2.198-.757-3.75-2.25-4.593a4.733 4.733 0 0 0-.54-.262c.473.96.639 2.042.475 3.099a5.57 5.57 0 0 1-.83 2.195.75.75 0 0 1-1.228-.863 3.923 3.923 0 0 0-.305-4.628c-2.532 1.426-3.928 3.492-4.14 6.149a9.776 9.776 0 0 0 .359 3.416c5.873.17 9.517 3.031 9.675 3.156a.75.75 0 0 1 .12 1.05ZM2.25 13.125a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm1.5 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0Z"
    />
  </SvgIcon>
);

HolidayIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default HolidayIcon;
